import React from 'react';
import MeetingsComponent from '../components/MeetingsComponent';
import { getUserName } from '../utils/Utils';

function MeetingsPage() {
  const [meetings, setMeetings] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  // Datos de ejemplo siguiendo estrictamente el esquema
  const fetchMeetings = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/meetings/`);
      const data = await res.json();
      //Para cada meeting, obtener el nombre del creador
      for (let meeting of data) {
        if (meeting.creator) {
          let username = await getUserName(meeting.creator);
          meeting.creator = {name:username, userId: meeting.creator};
        }
      }
      setMeetings(data);
    } catch (err) {
      console.error('Error cargando reuniones:', err);
    }
    finally {
      setLoading(false);
    }
  };

  const handleDelete = async (meetingId) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:3005'}/meetings/${meetingId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      });
      if (res.ok) {
        setMeetings(meetings.filter(m => m._id !== meetingId));
      } else {
        console.error('Error eliminando reunión:', res.statusText);
      }
    } catch (err) {
      console.error('Error eliminando reunión:', err);
    }
  };

  React.useEffect(() => {
    fetchMeetings();
  }, []);

  return (
    <div>
      <MeetingsComponent meetings={meetings} userId={localStorage.getItem("userId")} handleDelete={handleDelete} loading={loading} />
    </div>
  );
}

export default MeetingsPage;
